{
  "name": "experian-product-menu",
  "version": "9.0.3",
  "scripts": {
    "build": "ng build --configuration=prod",
    "build:stats": "ng build --configuration=prod --stats-json && npm run analyze",
    "commit": "git add . && git-cz",
    "lint": "ng lint",
    "ng": "ng",
    "prepare": "husky",
    "start": "ng serve --open --port=4200",
    "start:dev": "ng serve --configuration=dev --open",
    "start:prod": "ng serve --configuration=prod --open",
    "start:qa": "ng serve --configuration=qa --aot --open",
    "start:uat": "ng serve --configuration=uat --open",
    "test": "ng test --code-coverage --browsers=ChromeHeadless",
    "test:local": "ng test --code-coverage --browsers=Chrome --watch"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.18",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.18",
    "@angular/compiler": "^19.2.18",
    "@angular/core": "^19.2.18",
    "@angular/forms": "^19.2.18",
    "@angular/material": "^19.2.19",
    "@angular/platform-browser": "^19.2.18",
    "@angular/platform-browser-dynamic": "^19.2.18",
    "@angular/router": "^19.2.18",
    "@auth0/angular-jwt": "^5.2.0",
    "@datadog/browser-rum": "^6.27.1",
    "@popperjs/core": "^2.11.8",
    "experian-analytics-components": "^1.1.1",
    "experian-authentication-frontend-components": "^9.0.3",
    "experian-allowme-frontend": "1.2.3",
    "experian-change-app-components": "1.2.2",
    "experian-design-system": "^19.0.2",
    "experian-header-frontend-components": "^9.0.1",
    "experian-shared-frontend": "^9.0.1",
    "material-icons": "^1.13.12",
    "material-symbols": "^0.40.2",
    "ng-inline-svg-2": "^15.0.1",
    "ngx-guided-tour": "^2.0.1",
    "ng-otp-input": "^2.0.9",
    "ngx-mask": "^19.0.7",
    "rxjs": "^7.8.1",
    "tslib": "~2.5.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.2.19",
    "@angular-devkit/core": "^19.2.19",
    "@angular-eslint/builder": "^19.8.1",
    "@angular-eslint/eslint-plugin": "^19.8.1",
    "@angular-eslint/eslint-plugin-template": "^19.8.1",
    "@angular-eslint/schematics": "^19.8.1",
    "@angular-eslint/template-parser": "^19.8.1",
    "@angular/cli": "^19.2.19",
    "@angular/compiler-cli": "^19.2.17",
    "@angular/language-service": "~19.2.17",
    "@commitlint/cli": "^11.0.0",
    "@commitlint/config-conventional": "^11.0.0",
    "@types/jasmine": "^4.3.0",
    "@types/jasminewd2": "^2.0.11",
    "@typescript-eslint/eslint-plugin": "5.17.0",
    "@typescript-eslint/parser": "5.17.0",
    "commitizen": "^4.3.0",
    "eslint": "^8.57.0",
    "fetch-mock": "^12.5.3",
    "husky": "^9.1.7",
    "jasmine-core": "^5.5.0",
    "jasmine-reporters": "^2.4.0",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-cli": "^2.0.0",
    "karma-coverage": "^2.0.3",
    "karma-coverage-istanbul-reporter": "~3.0.2",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "^1.7.0",
    "ng-packagr": "^19.2.2",
    "prettier": "2.0.4",
    "standard-version": "^9.3.2",
    "ts-node": "~10.9.0",
    "typescript": "^5.8.0"
  },
  "config": {
    "commitizen": {
      "path": "./node_modules/cz-conventional-changelog"
    }
  }
}
